/**
 * AGRO-INVEST API Service
 * Centralized API calls to api.agroinvezt.tech
 */

import { getApiUrl } from '../config/api';

const defaultHeaders = {
  'Content-Type': 'application/json',
};

export const api = {
  async get(path, options = {}) {
    const res = await fetch(getApiUrl(path), {
      method: 'GET',
      headers: { ...defaultHeaders, ...options.headers },
      ...options,
    });
    return res.json?.() ?? res;
  },

  async post(path, data, options = {}) {
    const response = await fetch(getApiUrl(path), {
      method: 'POST',
      headers: { ...defaultHeaders, ...options.headers },
      body: data ? JSON.stringify(data) : undefined,
      ...options,
    });
    const json = await response.json?.().catch(() => ({}));
    if (!response.ok && !json.message) {
      return { success: false, message: response.statusText || 'Request failed' };
    }
    return json ?? {};
  },

  async put(path, data, options = {}) {
    const res = await fetch(getApiUrl(path), {
      method: 'PUT',
      headers: { ...defaultHeaders, ...options.headers },
      body: data ? JSON.stringify(data) : undefined,
      ...options,
    });
    return res.json?.() ?? res;
  },

  async patch(path, data, options = {}) {
    const res = await fetch(getApiUrl(path), {
      method: 'PATCH',
      headers: { ...defaultHeaders, ...options.headers },
      body: data ? JSON.stringify(data) : undefined,
      ...options,
    });
    return res.json?.() ?? res;
  },

  async delete(path, options = {}) {
    const res = await fetch(getApiUrl(path), {
      method: 'DELETE',
      headers: { ...defaultHeaders, ...options.headers },
      ...options,
    });
    return res.json?.() ?? res;
  },
};
